import { render } from "./PartnersContactsList.vue?vue&type=template&id=2f738a53&scoped=true"
import script from "./PartnersContactsList.vue?vue&type=script&lang=js"
export * from "./PartnersContactsList.vue?vue&type=script&lang=js"

import "./PartnersContactsList.vue?vue&type=style&index=0&id=2f738a53&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f738a53"]])

export default __exports__